export enum Status {
  VERY_GOOD = 'very_good',
  GOOD = 'good',
  BAD = 'bad',
  VERY_BAD = 'very_bad'
}

export const pastureStatusLabels: Record<Status, string> = {
  [Status.VERY_GOOD]: 'Muito Bom',
  [Status.GOOD]: 'Bom',
  [Status.BAD]: 'Ruim',
  [Status.VERY_BAD]: 'Muito Ruim'
}

export interface PastureDto {
  id: string
  idFazenda: string
  idPasto: string
  dataCriacao: string | null
  descricao: string
  area: number
  classificacao: Status | null
  saleiros: Status | null
  cerca: Status | null
  pasto: Status | null
  aguados: Status | null
  acao: string
  key: string
  animais: Array<{
    id: string
    idAnimal: string
    nome: string | null
    cdn: string | null
  }> | null
}

export interface PastureHistoricDto {
  id: string
  idFazendaIdPasto: string
  idHistorico: string
  idFazenda: string
  idPasto: string
  data: string
  descricao: string | null
  pasto: Status
  cerca: Status
  aguadas: Status
  saleiros: Status
  area: number | null
  acao: string
  key: string
}

export interface CreatePastureHistoricDto extends Omit<PastureHistoricDto, 'id' | 'idHistorico' | 'key' | 'acao'> {}
